import { getQueryStrings } from '@/utils/uri-utils';
import { isArray, isNoE } from '@/utils/obj-utils';
import { APP_CONST } from '@/utils/constants';
import { merge } from 'lodash';
import { getDeviceInfo } from '@/utils/dom-utils';
import useAppStore from '@/store/appStore';
import { canUseDOM } from '@/utils/dom-utils';

export const crmHooks = {
  beforeBuildOptions(method, url, params, data) {
    if (!data) {
      data = {};
    }
    const [sourceType, leadSubSource, leadFormName, vehicleModelOfInterest] = getQueryStrings(
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content'
    );
    const checkFields = { sourceType, leadSubSource, leadFormName, vehicleModelOfInterest };
    const keys = Object.keys(checkFields);
    for (let key of keys) {
      const checkVal = checkFields[key];
      if (isArray(checkVal) && checkVal.length > 0) {
        data[key] = checkVal[0];
      } else if (!isNoE(checkVal)) {
        data[key] = checkVal;
      }
    }
  },
  afterBuildOptions(options) {
    const { lang } = APP_CONST;
    const { data } = options;
    const checkFields = ['sourceType', 'leadSubSource', 'leadFormName', 'vehicleModelOfInterest'];

    // 确保 data 对象存在
    if (!data) {
      options.data = {};
    }

    // 优先从 appStore 获取 lang，其次使用 APP_CONST
    let appLang = lang;
    if (canUseDOM()) {
      const appStore = useAppStore();
      appLang = appStore.lang || lang;
    }

    merge(options, {
      data: {
        // language: appLang,
      },
    });

    for (let cf of checkFields) {
      const fieldVal = data?.[cf];
      if (isArray(fieldVal)) {
        data[cf] =
          fieldVal.length > 0 && !isNoE(fieldVal[0])
            ? fieldVal[0]
            : cf === 'sourceType'
              ? 'Official Website'
              : '';
      }
    }
  },
};
export const loginHooks = {
  afterBuildOptions(options) {
    const deviceInfo = getDeviceInfo();
    merge(options, {
      headers: {
        deviceName: deviceInfo.browser.name,
        model: deviceInfo.os.name,
        systemVersion: deviceInfo.os.version,
      },
    });
  },
};
